import {LOCALE} from 'features/ui/enums';
import {getCurrentLocale} from 'features/services/utils/env-helper';

export const AREA_FILTER_MIN = 0;
export const AREA_FILTER_MAX = getCurrentLocale() === LOCALE.FI ? 150 : 200;
